export const SHOW_LOADER = 'app/SHOW_LOADER';
